import { render } from "./EditPrix.vue?vue&type=template&id=5d4df273"
import script from "./EditPrix.vue?vue&type=script&lang=js"
export * from "./EditPrix.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/services/EditPrix.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d4df273"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d4df273', __exports__)) {
    console.log('reload')
    api.reload('5d4df273', __exports__)
  }
  
  module.hot.accept("./EditPrix.vue?vue&type=template&id=5d4df273", () => {
    console.log('re-render')
    api.rerender('5d4df273', render)
  })

}


export default __exports__